import { render } from "./App.vue?vue&type=template&id=6a51d685"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6a51d685&lang=css"
script.render = render

export default script